import { render, staticRenderFns } from "./ModalCadastroMatricula.vue?vue&type=template&id=4097ba56"
import script from "./ModalCadastroMatricula.vue?vue&type=script&lang=js"
export * from "./ModalCadastroMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports